import { tokens } from '@datacamp/waffles/tokens';
import React from 'react';
import { SessionOutputDisplayer } from './SessionOutput';
import { UserInputDisplayer } from './UserInputDisplayer';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ConsoleOutput = _ref => {
  let {
    className,
    colorizeCodeElement,
    outputs,
    theme
  } = _ref;
  return ___EmotionJSX("div", {
    className: className,
    style: {
      backgroundColor: theme === 'dark' ? tokens.colors.navy : tokens.colors.white,
      fontFamily: tokens.fontFamilies.mono,
      fontSize: tokens.fontSizes.medium,
      paddingLeft: 10
    }
  }, outputs.map((output, index) => {
    if (output.type === 'UserInput') {
      return ___EmotionJSX(UserInputDisplayer, {
        colorizeCodeElement: colorizeCodeElement,
        key: index,
        theme: theme,
        userInput: output.value
      });
    }
    const prevOutput = outputs[index - 1];
    return ___EmotionJSX(SessionOutputDisplayer, {
      key: index,
      sessionOutput: output.value,
      theme: theme,
      userInput: (prevOutput === null || prevOutput === void 0 ? void 0 : prevOutput.type) === 'UserInput' ? prevOutput.value : undefined
    });
  }));
};
export { ConsoleOutput };